import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Login';
import MainPage from './protected/Main';
import { ProtectedRoute } from './store/LoginFunction';
import ContactUsPage from './protected/ContactUs';
import AlarmRecordPage from './protected/AlarmRecord';
import FuelCalPage from './protected/FuelCal';
import ThermalCalPage from './protected/ThermalCal';
import NavbarLink from './Navbar';
import { Container } from 'react-bootstrap';

export default function App() {

  const Navbar: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    return (
      <div>
        <NavbarLink />
        <Container>
          {children}
        </Container>
      </div>
    );
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path='*' element={<Login />} />
          <Route path='/' element={<Login />} />

          <Route path='/main' element={
            <ProtectedRoute>
              <Navbar>
                <MainPage />
              </Navbar>
            </ProtectedRoute>
          } />

          <Route path='/alarm' element={
            <ProtectedRoute>
              <Navbar>
                <AlarmRecordPage />
              </Navbar>
            </ProtectedRoute>
          } />

          <Route path='/fuel' element={
            <ProtectedRoute>
              <Navbar>
                <FuelCalPage />
              </Navbar>
            </ProtectedRoute>
          } />

          <Route path='/thermal' element={
            <ProtectedRoute>
              <Navbar>
                <ThermalCalPage />
              </Navbar>
            </ProtectedRoute>
          } />

          <Route path='/contact' element={
            <ProtectedRoute>
              <Navbar>
                <ContactUsPage />
              </Navbar>
            </ProtectedRoute>
          } />

        </Routes>
      </div>
    </Router>
  );
}
